import React from 'react';
export function AddCircleFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.015 2H12a10 10 0 00-.015 20H12a10 10 0 00.015-20zM15 13h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2V9a1 1 0 011-1 1 1 0 011 1v2h2a1 1 0 010 2z"
  }));
}